import { Typography } from '../primitives/index.js'
import type { FC } from 'react'
import styles from './empty-links.module.css'

export interface EmptyLinksProps {
  text?: string
}

export const EmptyLinks: FC<EmptyLinksProps> = props => {
  const { text = 'No links' } = props
  return (
    <Typography
      className={styles.text}
      variant="caption"
    >
      {text}
    </Typography>
  )
}

export default EmptyLinks
